export const CHANGE_LOGIN = 'CHANGE_LOGIN'
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD'
export const SET_AUTH = 'SET_AUTH'
export const CHANGE_REMEMBER = 'CHANGE_REMEMBER'
export const SET_TOKEN = 'SET_TOKEN'
export const SET_USERID = 'SET_USERID'
export const SET_ROLE = 'SET_ROLE'
export const SET_LOADING= 'SET_LOADING'